var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCelebrationSteps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3802 10.7992L10.2703 10.5676C9.88573 9.9308 9.66594 9.06239 9.611 8.13607C9.50111 5.99397 10.2703 4.31501 11.4791 4.19922H11.5341C12.633 4.19922 13.622 5.70449 13.7868 7.7887C13.8418 8.71502 13.7319 9.58343 13.4572 10.2782L13.4022 10.5097H13.1824C12.7978 10.4519 12.3033 10.4519 11.9187 10.5097C11.4791 10.5097 11.0396 10.6255 10.655 10.7413L10.3802 10.7992Z",
    fill: "#006FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62098 10.1977L7.73087 9.96608C8.11549 9.32924 8.33528 8.46083 8.39022 7.53451C8.50011 5.3924 7.73087 3.71345 6.52207 3.59766H6.46713C5.36823 3.59766 4.37921 5.10293 4.21437 7.18714C4.15943 8.11346 4.26932 8.98187 4.54405 9.67661L4.59899 9.90818H4.81877C5.20339 9.85029 5.69789 9.85029 6.08251 9.90818C6.52207 9.90818 6.96164 10.024 7.34626 10.1398L7.62098 10.1977Z",
    fill: "#006FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7008 14.3984C10.7919 14.3984 10.1503 13.2984 10.2038 11.9984C10.2038 11.8984 10.2038 11.7484 10.2038 11.6484L10.2573 11.3984L13.1978 11.4984V11.7484C13.1978 11.8484 13.1978 11.9984 13.1978 12.0984C13.2513 13.3984 12.5562 14.3984 11.7008 14.3984Z",
    fill: "#006FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.30043 13.7969C7.20932 13.7969 7.85089 12.6969 7.79743 11.3969C7.79743 11.2969 7.79743 11.1469 7.79743 11.0469L7.74396 10.7969L4.80343 10.8969V11.1469C4.80343 11.2469 4.80343 11.3969 4.80343 11.4969C4.74996 12.7969 5.445 13.7969 6.30043 13.7969Z",
    fill: "#006FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelebrationSteps);
export default __webpack_public_path__ + "static/media/celebration-steps.8fe778d98fea453409cdacd2a90dc42b.svg";
export { ForwardRef as ReactComponent };